import { styled } from '@linaria/react';
import { layout, space } from '../../theme/tokens';

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};
  margin-top: ${space['space-1000']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: 0 min(${space['space-1400']}, 8.5%);
  }
`;

export const AddGuestRow = styled.div`
  display: flex;
`;
